import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { styles, colors, spacing } = theme.busbud;

  const headerAndFooterStyle: React.CSSProperties = {
    position: "sticky",
    zIndex: 1, // Places up the `filtersContainer`
    backgroundColor: colors.background.primary.translucent,
    backdropFilter: `blur(${styles.backgroundBlur.md})`,
    borderWidth: styles.borderWidth.sm,
    borderColor: colors.border.primary.transparent,
    padding: spacing(2.5)
  };

  return {
    header: {
      ...headerAndFooterStyle,
      padding: spacing(1.5),
      borderBottomStyle: "solid",
      top: 0,
      zIndex: 1
    },
    footer: {
      ...headerAndFooterStyle,
      padding: spacing(2.5, 2.5, 3),
      borderTopStyle: "solid",
      bottom: 0
    },
    filtersContainer: {
      flex: 1,
      padding: spacing(1.5, 2.5),
      zIndex: 0
    }
  };
});
